export const READ_GRADE = 'grades:READ_GRADE'
export const READ_GRADE_SUCCESS = 'grades:READ_GRADE_SUCCESS'
export const READ_GRADE_FAILURE = 'grades:READ_GRADE_FAILURE'

export const UPDATE_GRADE = 'grades UPDATE_GRADE'
export const UPDATE_GRADE_SUCCESS = 'grades UPDATE_GRADE_SUCCESS'
export const UPDATE_GRADE_FAILURE = 'grades UPDATE_GRADE_FAILURE'
